// extracted by mini-css-extract-plugin
export var funfactIcon = "funfacts-module--funfactIcon--UOpWL";
export var funfactItem = "funfacts-module--funfactItem--NL320";
export var funfactsRow = "funfacts-module--funfactsRow--FVOPI";
export var funfactsSection = "funfacts-module--funfactsSection--cVrYm";
export var funfactsSectionHead = "funfacts-module--funfactsSectionHead--DnxZl";
export var funfactsSectionTitle = "funfacts-module--funfactsSectionTitle--8jpXj";